import { render } from "./Pie.vue?vue&type=template&id=9338a752&scoped=true&lang=true"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"

import "./Pie.vue?vue&type=style&index=0&id=9338a752&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9338a752"]])

export default __exports__